jQuery( async ( $ ) => {

	const paymentTranslations = await $.get( red61.ajax_url, { action: 'get_translations', component: 'payment' } );
	const {translations} = paymentTranslations;

	window.translations = {
		...paymentTranslations.translations
	};


	if ( 0 < $( '#create-card-payment-order-wrapper' ).length ) {
		createCardPaymentOrderForm();
	}

	async function createCardPaymentOrderForm() {

		const screenColorDepth = screen.colorDepth; // 24
		const {language} = navigator; // en_US
		const screenHeight = screen.height; // 1080
		const screenWidth = screen.width; // 1920
		const {timeZone} = Intl.DateTimeFormat().resolvedOptions();
		const {userAgent} = navigator;

		const formData = new FormData();
		formData.append( 'action', 'create_card_payment_order' );

		formData.append( 'screenColorDepth', screenColorDepth );
		formData.append( 'language', language );
		formData.append( 'screenHeight', screenHeight );
		formData.append( 'screenWidth', screenWidth );
		formData.append( 'timeZone', timeZone );
		formData.append( 'userAgent', userAgent );

		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} );

		if ( response['orderCreated'] && 'azredcard' === response['provider'] ) {
			// If there has not been a payment error then redirect to AZ payment page
			if ( 0 === $( '#error-message' ).length ) {
				const providerData = JSON.parse( response['providerData'] );
				let paymentUrl;
				if ( providerData['url'].toLowerCase().includes( 'test' ) ) {
					paymentUrl = providerData['url'];
				} else {
					paymentUrl = providerData['url'].replace ( 'auth.andersonzaks.com:7360', 'azwebpay.com' );
				}
				window.location.replace( paymentUrl );
			}
			$( '#create-card-payment-order-wrapper' ).html( response['paymentFormHTML'] );
			$( '.loading-payment-text' ).html( translations['If page does not load then please click the link below.'] || 'If page does not load then please click the link below.' );
		} else if ( response['orderCreated'] ) {
			$( '#create-card-payment-order-wrapper' ).html( response['paymentFormHTML'] );
			$( '.loading-payment-text' ).empty( response );

		} else {
			const errorMessage = response['statusMesssage'];
			const provider = response['provider'];

			console.log( 'Payment form failed to load, error message was : ', errorMessage );
			if( 'eselectplus' === provider ) {
				window.location.replace( `/account-edit?errorMessage=${encodeURIComponent( errorMessage )}` );
			} else {
				$( '#create-card-payment-order-wrapper' ).html( errorMessage );
			}

		}
	}

} );
